<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-chalkboard-teacher_bk.png" alt width="27.3" height="25.2" />
      <p class="title-bk">先生管理</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'teacher' }">戻る</router-link>
    </div>
    <div class="container">
      <label>先生凍結 ー </label>
      <label class="label lb-red">注意：この作業はスタッフ二人以上で確認の上実行してください</label>
      <table class="table">
        <tbody>
          <tr>
            <th scope="row" width="30%">法人名（法人ID）：</th>
            <td>{{ currentCorporationDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">ブランド名（ブランドID）：</th>
            <td>{{ currentBrandDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">先生名（先生ID）</th>
            <td>{{ currentTeacherDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">凍結開始月：</th>
            <td>
              <v-select
                tag="div"
                v-model="frozenMonth"
                placeholder="選択してください"
                class="custom-select mr-sm-2"
                id="inlineFormCustomSelect-2"
                style="width: 180px;"
                :clearable="false"
                :options="frozenMonthJPs"
                :reduce="(option) => option.value"
                label="text"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table">
        <tbody>
          <tr>
            <th scope="row">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="column-display-check-0"
                  v-model="noStudentChecked"
                />
                <label class="custom-control-label" for="column-display-check-0">
                  この先生に関連づけられている全てのクラスは、先生（担当・メイン）の変更を実行しました。
                  <br />
                  もしくは、生徒が一人も紐づけられていないクラスだけが紐づけられていることを確認しました。
                </label>
              </div>
            </th>
          </tr>
          <tr>
            <th scope="row">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="column-display-check-1"
                  v-model="noContinueStudyingChecked"
                />
                <label class="custom-control-label" for="column-display-check-1">
                  実行していない場合、この先生が「担当・メイン」になっているクラスも凍結処理されます。
                  <br />
                  この場合、学習できなくなる生徒が現れる可能性があることを理解しています。
                </label>
              </div>
            </th>
          </tr>
        </tbody>
      </table>
      <div class="m-5 text-center">
        <button
          type="button"
          class="btn btn-red"
          @click="confirmFrozen"
          :disabled="!frozenMonth || !noStudentChecked || !noContinueStudyingChecked"
        >
          凍結実行
        </button>
      </div>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        :green-button-title="requestError ? '閉じる' : '一覧に戻る'"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header>{{ requestError ? 'エラー' : '先生凍結' }}</template>
        <template v-slot:body>{{ requestError ? requestError : '先生の凍結、または凍結予約が完了しました' }}</template>
      </PopUpHolder>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions } from 'vuex';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import store from '@/store/index.js';
import { basicCorporationNameIdPresent, basicBrandNameIdPresent, basicTeacherNameIdPresent } from '@/presenters/fields';
import { nextNMonthJPs } from '@/utils/year_helpers';
import { nextNDayJPs } from '@/utils/date_helpers';

export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('teacher/fetchTeacher', routeTo.params.id).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  components: {
    PopUpHolder,
  },
  data() {
    return {
      frozenMonth: null,
      noStudentChecked: false,
      noContinueStudyingChecked: false,
      requestError: null,
    };
  },
  computed: {
    currentTeacher() {
      return this.teacher.teacher;
    },
    currentCorporationDisplay() {
      return basicCorporationNameIdPresent(this.currentTeacher.corporation);
    },
    currentBrandDisplay() {
      return basicBrandNameIdPresent(this.currentTeacher.brand);
    },
    currentTeacherDisplay() {
      return basicTeacherNameIdPresent(this.currentTeacher);
    },
    frozenMonthJPs() {
      let numberOfMonths = 12;
      let arrayOfMonths = [];
      if (Vue.config.stagingBuild) {
        arrayOfMonths = nextNDayJPs(numberOfMonths);
      } else {
        arrayOfMonths = nextNMonthJPs(numberOfMonths);
      }
      arrayOfMonths.unshift({
        value: 'now',
        text: '今すぐ凍結',
      });
      return arrayOfMonths;
    },
    ...mapState(['teacher']),
  },
  methods: {
    confirmFrozen() {
      this.requestError = null;
      this.$logger.debug('Confirm frozen');
      let payload = {
        id: this.currentTeacher.id,
        frozenMonth: this.frozenMonth,
      };
      this.freezeTeacher(payload)
        .then(() => {
          this.$logger.debug('Show success popup');
          this.$refs['popup_holder'].show();
        })
        .catch((error) => {
          this.requestError = error.response.data.error;
          this.$logger.debug('Show error popup', this.requestError);
          this.$refs['popup_holder'].show();
        });
    },
    popupConfirmed() {
      if (this.requestError) {
        this.$logger.debug('Popup error done');
      } else {
        this.$logger.debug('Popup done');
        this.$router.push({ name: 'teacher' });
      }
    },
    ...mapActions('teacher', ['freezeTeacher']),
  },
};
</script>

<style scoped>
.btn-red {
  margin-left: 0px;
}
.lb-red {
  color: red;
  margin-left: 5px;
}
.custom-control-label {
  font-weight: normal;
  font-size: 13px;
}
</style>
